import axios from 'axios';
import { config_headers, URL_API ,servicelist } from '../Config';

export const P301DashboardList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.ExecutiveService}/p_executive_dashboard_branch_info`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P301GetDataChart_1= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.ExecutiveService}p_executive_dashboard_branch_graph_1`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P301GetDataChart_2= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.ExecutiveService}p_executive_dashboard_branch_graph_2`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}

export const P301GetDataChart_3= async (body) => {

    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.ExecutiveService}p_executive_dashboard_branch_graph_3`), body, authorization )
                .then(res => {
                    resolve(res.data);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}


